<template>
  <div class="follow-box" v-loading="loading">
    <div class="title">{{ $t('我的关注') }}</div>
    <div v-if="list.length" class="list">
      <div class="row df aic" v-for="item in list" :key="item.user_id" @click="openUser(item)">
        <el-avatar :size="44" :src="item.user_avatar_att_url">
          <img src="@/assets/images/avatar.png" alt="">
        </el-avatar>
        <div class="info f1 over-h">
          <p class="name one-text">{{ item.user_nick_name || $t('匿名用户') }}</p>
          <div class="tags one-text" v-if="item.user_excel_arr && item.user_excel_arr.length">
            <span v-for="tag in item.user_excel_arr" :key="tag.value || tag.label">{{ tag.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-else-if="!loading">
      <img src="@/assets/images/empty_data.png" alt="" />
      <p>{{ $t('暂无数据') }}</p>
    </div>
    <div class="pageing-box df aic jcc" v-if="total > pageSize">
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="prev, pager, next"
        @current-change="handlePage"
      />
    </div>
    <avatar-dialog ref="avatarDialog" :id="currentUserId" @post-submitted="handleFollow" />
  </div>
</template>

<script>
import { getMyFollow } from "@api/usercenter";
import { setuserfollowAdd } from "@api/home";
import avatarDialog from "@comp/avatar.vue";

export default {
  name: "PersonalFollow",
  components: { avatarDialog },
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      currentUserId: 0,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await getMyFollow({ page: this.page, pagesize: this.pageSize });
        if (res && res.status == 200) {
          const pageData = res.data || {};
          this.list = pageData.data || [];
          this.total = pageData.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },
    handlePage(page) {
      this.page = page;
      this.load();
    },
    openUser(item) {
      this.currentUserId = item.user_id;
      this.$nextTick(() => {
        this.$refs.avatarDialog.openModal();
      });
    },
    async handleFollow(id) {
      const res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res && res.status == 200) {
        this.$message.success(res.msg);
        this.load();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-box {
  min-height: 320px;
  padding: 8px 8px 24px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}
.row {
  padding: 14px 8px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  &:hover {
    background: #fafafa;
  }
}
.info {
  margin-left: 14px;
}
.name {
  font-size: 16px;
  color: #191919;
  margin: 0;
}
.tags {
  margin-top: 6px;
  span {
    display: inline-block;
    margin-right: 8px;
    padding: 0 8px;
    line-height: 22px;
    font-size: 12px;
    color: #b7251e;
    background: #fff1f0;
    border-radius: 4px;
  }
}
.no-data {
  text-align: center;
  padding: 48px 0;
  color: #999;
  img {
    width: 160px;
  }
}
.pageing-box {
  margin-top: 20px;
}
</style>
